const passengers = {
  table: {
    headers: {
      supplier: 'Fleet',
    }
  },
  forms: {
    information: {
      supplier: {
        header: 'Fleet',
        fields: {
          label: 'Preferred Fleet',
        },
      },
    },
  },
};

export default passengers;
